import heic2any from "heic2any";
import UTIF from "utif";

export default class ImageConvertor {
  static convertImage = async (file) => {
    const blobURL = URL.createObjectURL(file);
    let res = await fetch(blobURL)
      .then((res) => res.blob())
      .then((blob) => heic2any({ blob, toType: "image/jpeg" }))
      .then((conversionResult) => {
        return conversionResult;
      })
      .catch((e) => { });
    return res;
  };
}

export async function convertTiffToJpeg(tiffFile) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const arrayBuffer = e.target.result;
        if (!arrayBuffer || arrayBuffer.byteLength === 0) {
          throw new Error('Empty or invalid file data');
        }
        const ifds = UTIF.decode(arrayBuffer);
        if (!ifds || ifds.length === 0) {
          throw new Error('No images found in TIFF file');
        }
        const firstPage = ifds[0];
        UTIF.decodeImage(arrayBuffer, firstPage);

        if (!firstPage.width || !firstPage.height ||
          firstPage.width <= 0 || firstPage.height <= 0) {
          throw new Error(`Invalid image dimensions: ${firstPage.width}x${firstPage.height}`);
        }
        const rgba = UTIF.toRGBA8(firstPage);
        if (!rgba || rgba.length === 0) {
          throw new Error('Failed to convert TIFF to RGBA');
        }
        const canvas = document.createElement('canvas');
        canvas.width = firstPage.width;
        canvas.height = firstPage.height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          throw new Error('Could not get canvas context');
        }
        const imageData = new ImageData(
          new Uint8ClampedArray(rgba),
          firstPage.width,
          firstPage.height
        );
        ctx.putImageData(imageData, 0, 0);
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error('Failed to create JPEG blob'));
              return;
            }
            resolve(blob);
          },
          'image/jpeg',
          0.8
        );
      } catch (error) {
        console.error('TIFF conversion error:', error);
        reject(new Error(`Failed to convert TIFF: ${error.message}`));
      }
    };
    reader.onerror = () => {
      reject(new Error('Failed to read the TIFF file'));
    };

    reader.readAsArrayBuffer(tiffFile);
  });
}

export function getTruncatedFilename(doc) {
  if (!doc) return '';
  const fullName = doc.name || doc.fileName || doc.textAndUrl || (doc.file && doc.file.name) || '';
  const validExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.jpg', '.jpeg', '.png', '.heic', '.gif', '.ppt', '.pptx', '.numbers', '.pages', '.tiff', '.mp4', '.m4v', '.mid', '.mkv', '.webm', '.mov', '.avi', '.wmv'];
  const lastDotIndex = fullName.lastIndexOf('.');
  const extension = lastDotIndex > 0 ? fullName.slice(lastDotIndex).toLowerCase() : '';
  if (!validExtensions.includes(extension)) {
    return fullName;
  }
  if (lastDotIndex <= 0) {
    return fullName.length > 30 ? fullName.slice(0, 27) + '... ' : fullName;
  }
  const namePart = fullName.slice(0, lastDotIndex);
  const maxNameLength = Math.max(0, 27 - extension.length);
  if (namePart.length > maxNameLength) {
    return namePart.slice(0, maxNameLength) + '... ' + extension;
  }
  return fullName;
}


// WEBPACK FOOTER //
// ./src/utils/ImageConvertor.js